import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { ProductionIP, SaveStatusObj, SSOStatus, SOModule, SaveEventType, SalesOrder, ValidationItem, ValidationSummary, ActualDateChange, PlannedDateToken, ActualDateToken, RequestDateToken } from '../../../shared/misc-classes';
import { DataService } from '../../../shared/dataservice.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ValidationDialog } from '../../../dialogs/validation-dialog/validation-dialog';
import { ActualDateDialog } from '../../../dialogs/actual-date-dialog/actual-date-dialog';

@Component({
  selector: 'production',
  templateUrl: './production.component.html',
  styleUrls: ['./production.component.css']
})
export class ProductionComponent implements OnInit,OnChanges {

  @Input() productionObj: ProductionIP;
  @Input() soLockObtained:boolean;
  @Input() loadCounter:SalesOrder;
  @Output() updateSubSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  disableForm: boolean = true;

  public _SSOStatus = SSOStatus;
Hvr:any={};
  modifyReqDate:boolean = false;
  modifyPlanDate:boolean = false;
  inputDisableMessage :string= 'This input is not yet enabled';
  constructor(public _dataService: DataService, public dialog: MatDialog) { }

  ngOnInit() {
    this.modifyPlanDate = this._dataService.modifyPlanDate;
    this.modifyReqDate = this._dataService.modifyReqDate;
  }

  ngOnChanges()  {
    this.disableForm = true;
    if(this.soLockObtained == false){
      this.inputDisableMessage = "You can't Edit, Sale Order Lock NOT obtained.";
    }
    else if (!this.productionObj.isProjectLive) {
      this.inputDisableMessage = "Project is on HOLD or TO BE CANCELLED";
    }
    else if (!this.productionObj.isInputEnabled) {
      this.inputDisableMessage = "This form is not yet enabled";
    }
    else if (!this._dataService.hasProductionEditAccess) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
    }
  }
  saveSso(_submitToNextSection:boolean,ssoSubmitTo:SSOStatus = SSOStatus.Not_Started){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data),
          null,
          ssoSubmitTo
        ));
    }
  }

  showSsoValidation(){
    let _validList:Array<ValidationItem> = [
      new ValidationItem("Mechanical Sticker Actual Date", (this.productionObj.mechanicalStickerActualDate ? true : false)," required to move to testing." )
    ] ;

    let vSummaryObj:ValidationSummary = new ValidationSummary("Validation Summary.",_validList);
    
    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }

  reloadData() {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Reload_Data));
    }

  }
  deleteSSo(_deleteSO:boolean){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Delete_SubSale_Order));
    }
  }

  requestDateChangeHandler(_reqDateHeader:string, _reqTokenKeyName:string,_plndReqDate:Date,_reqDateChanged:Date):void{
    let _plndDateChangeObj:ActualDateChange = new ActualDateChange("Why is the request date changed ?", _reqDateHeader + "(existing)", 
    _plndReqDate, _reqDateHeader + "(edited)", _reqDateChanged, this.productionObj[_reqTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.productionObj[_reqTokenKeyName].requestDate = _reqDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.productionObj[_reqTokenKeyName] = 
          new RequestDateToken(new Date(_reqDateChanged.getTime()), true, null, _plndDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.productionObj[_reqTokenKeyName].requestDate = _plndReqDate;
      }
    });
  }

  plannedDateChangeHandler(_plndDateHeader:string, _plndTokenKeyName:string,_plndDate:Date,_plndDateChanged:Date):void{
    let _plndDateChangeObj:ActualDateChange = new ActualDateChange("Why is the planned date changed ?", _plndDateHeader + "(existing)", 
                                                  _plndDate, _plndDateHeader + "(edited)", _plndDateChanged, this.productionObj[_plndTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.productionObj[_plndTokenKeyName].plannedDate = _plndDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.productionObj[_plndTokenKeyName] = 
          new PlannedDateToken(new Date(_plndDateChanged.getTime()), true, null, _plndDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.productionObj[_plndTokenKeyName].plannedDate = _plndDate;
      }
    });
  }

  actualDateChangeHandler(_actDateHeader:string,_actDate:Date,_actDateChanged:Date,_actTokenKeyName:string,_plndDateHeader:string,_plndDate:Date,):void{
    let _actDateChangeObj:ActualDateChange = new ActualDateChange("Additional Comment", _plndDateHeader, _plndDate, _actDateHeader, 
                                                              _actDateChanged, this.productionObj[_actTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _actDateChangeObj
    });
    let _prevActualDate:Date = this.productionObj[_actTokenKeyName].actualDate;
    this.productionObj[_actTokenKeyName].actualDate = _actDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.productionObj[_actTokenKeyName].actualDate = _actDateChangeObj.actualDate;
        var changedDate: Date = null;
        if(_actDateChangeObj.actualDate != null){
          changedDate = new Date(_actDateChangeObj.actualDate.getTime());
        }
        this.productionObj[_actTokenKeyName] = 
          new ActualDateToken(changedDate, true, _plndDate, _actDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.productionObj[_actTokenKeyName].actualDate = _prevActualDate;
      }
    });
  }
}
